var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJourneyWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49364 0.288264L11.9236 9.8018C11.9737 9.88945 12 9.98888 12 10.0901C12 10.1913 11.9737 10.2907 11.9236 10.3784C11.8736 10.466 11.8017 10.5388 11.715 10.5894C11.6283 10.64 11.5301 10.6667 11.43 10.6667H0.570004C0.469946 10.6667 0.371652 10.64 0.285 10.5894C0.198348 10.5388 0.126392 10.466 0.0763644 10.3784C0.0263365 10.2907 -6.35474e-07 10.1913 0 10.0901C6.35497e-07 9.98888 0.0263391 9.88945 0.076368 9.8018L5.50636 0.288264C5.5564 0.200619 5.62835 0.12784 5.715 0.0772393C5.80165 0.0266388 5.89995 0 6 0C6.10005 0 6.19835 0.0266388 6.285 0.0772393C6.37165 0.12784 6.4436 0.200619 6.49364 0.288264ZM5.42998 7.78378V8.93693H6.57002V7.78378H5.42998ZM5.42998 3.74773V6.63062H6.57002V3.74773H5.42998Z",
    fill: "#FA7319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyWarningIcon);
export default __webpack_public_path__ + "static/media/journey_warning_icon.8ffcd8cfc599a9bb72010227710a9318.svg";
export { ForwardRef as ReactComponent };